export const EXTENSION_HRS_ID = 'extensionHrs';
export const EXTENSION_MINS_ID = 'extensionMins';
export const END_ENGAGEMENT_MANAGEMENT_ID = 'engagementManaged';
